export const cloneConfigModal = {
  close: "Fechar",
  searchPlaceholder: "Buscar anúncio…",
  clearSearch: "Limpar",
  bar: {
    chooseSource: "Escolha o anúncio de origem",
    selected: "{count} selecionado | {count} selecionados",
    selectAll: "Selecionar todos",
    clear: "Limpar",
  },
  list: {
    loading: "Carregando anúncios…",
    empty: "Nenhum anúncio corresponde à sua busca.",
    unitsBadge: "{count} unidades",
  },
  confirm: {
    sourceLabel: "Origem escolhida",
    applyToLabel: "Será aplicado a",
    andItsUnits: "(e suas {count} unidades)",
    andMore: "e mais {count}",
    undoWarning: "Esta ação não pode ser desfeita.",
  },
  footer: {
    back: "Voltar",
    cancel: "Cancelar",
    continue: "Continuar",
  },
  preview: {
    unit: "Unidade",
    listing: "Anúncio",
    empty: "Não configurado.",
    loading: "Carregando…",
  },
  confirmTitle: {
    pull: "Confirme antes de trazer",
    push: "Revise antes de copiar",
  },
  confirmLabel: {
    pulling: "Trazendo…",
    copying: "Copiando…",
    confirmPull: "Sim, trazer configurações",
    confirmPush: "Sim, copiar para {count} anúncio | Sim, copiar para {count} anúncios",
  },
  intro: {
    pullLead: "Você está prestes a trazer {noun} do anúncio que escolheu.",
    pullReplace: "Isso substituirá o que você tem aqui agora.",
    pullAdd: "Isso será adicionado ao que você já tem aqui.",
    pushLead: "Você está prestes a copiar {noun} para {count} anúncio. | Você está prestes a copiar {noun} para {count} anúncios.",
    pushReplace: "Isso substituirá o que ele tem agora{scope}. | Isso substituirá o que eles têm agora{scope}.",
    pushAdd: "Isso será adicionado ao que ele já tem. | Isso será adicionado ao que eles já têm.",
    pushScope: ", incluindo as configurações de envio",
  },
  attachments: {
    fileFallback: "Anexo",
    titleAlsoCopied: "Os anexos também são copiados",
    titlePullLose: "Você perderá os anexos que tem agora",
    titlePullGain: "Os anexos dele também virão",
    titlePushEmpty: "Os anúncios escolhidos ficarão sem anexos",
    noteUnknownPull: "Os anexos do anúncio que você escolheu substituirão os daqui, que serão excluídos.",
    noteUnknownPush: "Os anexos deste anúncio substituirão os dos anúncios escolhidos, que serão excluídos.",
    notePullReplace: "Eles serão excluídos e substituídos pelos do anúncio que você escolheu.",
    notePullEmpty: "Não há anexos aqui no momento, então você não perde nada: os do anúncio escolhido virão.",
    notePushEmpty: "Este anúncio não tem anexos, então os do anúncio escolhido serão excluídos e ele ficará sem nenhum. | Este anúncio não tem anexos, então os dos anúncios escolhidos serão excluídos e eles ficarão sem nenhum.",
    notePushReplace: "Eles serão copiados para o anúncio escolhido e substituirão os dele, que serão excluídos. | Eles serão copiados para os anúncios escolhidos e substituirão os deles, que serão excluídos.",
  },
  toast: {
    loadError: "Não foi possível carregar os anúncios",
    pullSuccess: "Configurações trazidas com sucesso",
    pushSuccess: "Configurações copiadas para {count} anúncio | Configurações copiadas para {count} anúncios",
    pullError: "Não foi possível trazer as configurações",
    pushError: "Não foi possível copiar as configurações",
  },
};
